<template>
  <div>
    <el-card>
      <div slot="header">{{$t('createuser')}}</div>
      <div>
        <el-form
          :model="user"
          ref="user"
          @submit.native.prevent="submit"
          :rules="rules"
          @validate="validated($event)"
        >
          <el-form-item prop="username">
            <el-input v-model="user.username" :placeholder="$t('enterstreetnumber')"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="user.password" :placeholder="$t('enterpassword')" show-password></el-input>
          </el-form-item>
          <el-form-item prop="repeat">
            <el-input v-model="user.repeat" :placeholder="$t('repeatpassword')" show-password></el-input>
          </el-form-item>
          <el-row type="flex" justify="end" class="buttons">
            <el-button @click="submit($event)" native-type="submit" type="primary" round>{{$t('create')}}</el-button>
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import env from "@/environments/environment";

export default {
  name: "User",
  data() {
    const validateEquity = (v1, v2) => (rule, value, callback) => {
      if (this.user[v1] !== this.user[v2]) {
        callback(
          new Error(rule.message || `${this.user[v1]} !== ${this.user[v2]}`)
        );
      }
      callback();
    };

    return {
      revalidating: false,
      rules: {
        username: [
          {
            required: true,
            message: `${this.$t('enterusername')}`,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: `${this.$t('enterpassword')}`,
            trigger: "blur"
          },
          {
            message: `${this.$t('notthesamepassword')}`,
            trigger: "blur",
            validator: validateEquity("password", "repeat")
          }
        ],
        repeat: [
          {
            required: true,
            message: `${this.$t('enterpasswordagain')}`,
            trigger: "blur"
          },
          {
            message: `${this.$t('notthesamepassword')}`,
            trigger: "blur",
            validator: validateEquity("repeat", "password")
          }
        ]
      },
      user: {
        username: null,
        password: null,
        repeat: null
      }
    };
  },
  methods: {
    validated(event) {
      if (["repeat", "password"].indexOf(event) > -1) {
        if (!this.revalidating) {
          setTimeout(() => this.$refs.user.validateField(
            event === "repeat" ? "password" : "repeat"
          ));
          this.revalidating = true;
        } else {
          this.revalidating = false;
        }
      }
    },
    async submit(event) {
      event.preventDefault();
      try {
        await this.$refs.user.validate();

        console.log({ ...this.user });

        const user = { ...this.user };
        delete user.repeat;

        this.$emit("input", user);
      } catch (e) {
        console.log("invalid", e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
